
/**
 * MODAL DE CONFIRMATION DE SUPPRESSION
 * @param {Object} props
 * @param {Function} props.onConfirm - Callback confirmation
 * @param {Function} props.onCancel - Callback annulation
 * @param {boolean} props.isDeleting - État de chargement
 */
const DeleteConfirmationModal = ({ onConfirm, onCancel, isDeleting }) => {
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title text-danger">Confirmation de suppression</h5>
            <button type="button" className="btn-close" onClick={onCancel}></button>
          </div>
          
          <div className="modal-body text-center py-4">
            {isDeleting ? (
              <div className="d-flex align-items-center justify-content-center">
                <div className="spinner-border text-primary me-3" role="status"></div>
                <span>Suppression en cours...</span>
              </div>
            ) : (
              <>
                <div className="text-warning mb-3">
                  <i className="fas fa-exclamation-triangle fa-3x"></i>
                </div>
                <p className="mb-0">
                  Êtes-vous sûr de vouloir supprimer ce domaine ? Cette action est irréversible.
                </p>
              </>
            )}
          </div>
          
          {!isDeleting && (
            <div className="modal-footer border-0">
              <button type="button" className="btn btn-secondary" onClick={onCancel}>
                Annuler
              </button>
              <button type="button" className="btn btn-danger" onClick={onConfirm}>
                Confirmer la suppression
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;